/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Rulesetscount2Inputs */

const de_entity_rulesetscount2 = /** @type {(inputs: Entity_Rulesetscount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl Regeln`)
};

/** @type {(inputs: Entity_Rulesetscount2Inputs) => LocalizedString} */
const en_entity_rulesetscount2 = de_entity_rulesetscount2;

/**

* @param {Entity_Rulesetscount2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_rulesetscount2 = /** @type {((inputs?: Entity_Rulesetscount2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Rulesetscount2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_rulesetscount2(inputs)
	return de_entity_rulesetscount2(inputs)
});
export { entity_rulesetscount2 as "entity_ruleSetsCount" }